<div class="content-with-side-menu">
    <div class="row no-gutters">
        <div class="col-md-auto">
            <app-purchase-search-criteria
                hznTestId="purchase-list-filters"
                [searchForm]="searchForm"
                [filteredMember]="filteredMember"
                [filters]="filters"
                (membershipSelected)="onMembershipSelected($event)"
            >
            </app-purchase-search-criteria>
        </div>

        <div class="col">
            <div
                class="row no-gutters top-panel height-80 line-height-40 padding-20"
            >
                <div class="col" [formGroup]="searchForm">
                    <div class="form-check form-check-inline">
                        <input
                            hznTestId="purchase-list-status-finalized"
                            formControlName="showFinalized"
                            class="form-check-input"
                            type="checkbox"
                            id="inlineCheckbox1"
                            value="option1"
                        />
                        <label
                            class="form-check-label main-green bolded"
                            for="inlineCheckbox1"
                            >{{
                                "CampPurchaseStatus.Finalized" | translate
                            }}</label
                        >
                    </div>
                    <div class="form-check form-check-inline">
                        <input
                            hznTestId="purchase-list-status-refunded"
                            formControlName="showRefunded"
                            class="form-check-input"
                            type="checkbox"
                            id="inlineCheckbox2"
                            value="option2"
                        />
                        <label
                            class="form-check-label main-red bolded"
                            for="inlineCheckbox2"
                            >{{
                                "CampPurchaseStatus.Refunded" | translate
                            }}</label
                        >
                    </div>
                </div>
                <div class="col">
                    <div class="right">
                        <app-sort-camps
                            hznTestId="purchase-list-sort"
                            [sorting]="sorting"
                            [model]="searchForm.controls['sorting'].value"
                            (changed)="sortChanged()"
                        ></app-sort-camps>
                    </div>
                </div>
            </div>

            <div>
                <bcu-local-spinner
                    [size]="50"
                    [visible]="isBusy"
                ></bcu-local-spinner>

                <div
                    class="list-group list-group-flush"
                    infinite-scroll
                    [infiniteScrollDistance]="0.1"
                    [infiniteScrollThrottle]="300"
                    [infiniteScrollDisabled]="isBusy"
                    (scrolled)="onScroll()"
                >
                    @for (item of items; track item) {
                        <div
                            class="list-group-item list-group-item-action flex-column align-items-start clickable"
                            (click)="onItemSelected(item)"
                        >
                            <app-purchase-list-row
                                hznTestId="purchase-list-row"
                                [item]="item"
                            ></app-purchase-list-row>
                        </div>
                    }
                    @if (noItems && !isBusy) {
                        <div class="no-items-info padding-20" hznTestId="purchase-list-no-items">
                            <span>{{
                                "PurchaseList.noItems" | translate
                            }}</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
